export default "__VITE_ASSET__DtBySgjk__"